import styles from "./searchBar.module.scss";
// import search from "../../../../shared-assets/icons/search.png";
import Search from "../../../../shared-assets/Svg/SearchMod.svg";
import closeSearch from "../../../../shared-assets/icons/close-search.png";
import RemoveSearch from "../../../../shared-assets/Svg/RemoveSearch.svg";
import Image from "next/image";
import { useContext, useEffect, useMemo, useState } from "react";
import ResultSearch from "./resultSearch";
import FetchData from "../fetch-data/fetch-data";
import { API } from "../../../services/api-services";
import { SearchResponse } from "../../../models/search-response";
import { filterProductType } from "../../../services/product-service";
import AppContext from "../../../services/app-context-services";
import debouce from "lodash.debounce";
import { Mask } from "../mask/mask";

type searchBarProps = {
  showSearchBar: boolean;
  setShowSearchBar: (showSearchBar: boolean) => void;
  isFocus: boolean;
  setIsFocus: (focus: boolean) => void;
};

const SearchBar = ({
  showSearchBar,
  setShowSearchBar,
  isFocus,
  setIsFocus
}: searchBarProps) => {
  const appCtx = useContext(AppContext);
  const { isLoggedIn } = appCtx;
  // const [isFocus, setIsFocus] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [counter, setCounter] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(0);
  const [limit, setLimit] = useState(18);

  const [resultData, setResultData] = useState<SearchResponse>({
    products: []
  });
  const searchWrapperFull = {
    display: "flex",
    margin: 0,
    borderRadius: 0,
    backgroundColor: "#E7EAF0",
    height: "100%",
    width: "100% ",
    flexBasis: "100%"
  };

  const debouncedResults = useMemo(() => {
    return debouce(setCounter, 300);
  }, [counter, selectedCategory]);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  });

  useEffect(() => {
    if (searchTerm?.length <= 2) {
      setResultData({ products: [] });
      setLimit(13);
    }
  }, [searchTerm]);

  useEffect(() => {
    setCounter(prev => prev + 1);
  }, [selectedCategory, limit]);

  return (
    <>
      <div
        className={styles.container}
        // style={showSearchBar ? searchWrapperFull : {}}
      >
        {searchTerm.length > 2 && (
          <FetchData
            url={API.request_search_tag}
            method="POST"
            pendingHandlerSetter={loadingState => setLoading(loadingState)}
            counter={counter}
            body={JSON.stringify({
              category: selectedCategory,
              limit: limit,
              tag: searchTerm
            })}
            onSuccessful={data => {
              const searchResult = {
                products: (data as SearchResponse)?.products?.filter(item =>
                  filterProductType(item?.product_type)
                )
              };
              searchResult.products.pop();
              setResultData(searchResult);
              // setSearchResult(searchResult);
              // saveKey(query);
            }}
            unAuthorized={!isLoggedIn}
            with_dg_id
          />
        )}

        <div
          className={isFocus ? styles.searchWrapperFocus : styles.searchWrapper}
          style={showSearchBar ? searchWrapperFull : {}}
        >
          <span className={styles.searchIcon}>
            <Search />
          </span>

          <input
            type="text"
            className={styles.searchBox}
            placeholder="جستجوی کارتون و..."
            onFocus={() => setIsFocus(true)}
            onChange={e => {
              setSearchTerm(e.target.value);
              setCounter(prev => prev + 1);
            }}
            value={searchTerm}
          />

          <span
            className={styles.closeIcon}
            onClick={() => {
              setShowSearchBar(false);
              setIsFocus(false);
              setSearchTerm("");
            }}
          >
            <RemoveSearch />
          </span>
          {searchTerm?.length > 0 && (
            <span
              className={styles.removeSearch}
              onClick={() => setSearchTerm("")}
            >
              <RemoveSearch />
            </span>
          )}
        </div>
        <ResultSearch
          isFocus={isFocus}
          resultData={resultData}
          setSelectedCategory={setSelectedCategory}
          selectedCategory={selectedCategory}
          searchTerm={searchTerm}
          loading={loading}
          setLimit={setLimit}
          limit={limit}
        />

        {/* {isFocus &&
        createPortal(
          <div
            className={`${styles.searchBackdrop} `}
            onClick={() => setIsFocus(false)}
          ></div>,
          document.body
        )} */}
      </div>
    </>
  );
};

export default SearchBar;
